import { AttachmentsModel } from '@/features/attachment/_models/attachment';
import { BackendBaseModel } from '@/utils';
import { z } from 'zod';

import { FileEntryModel } from './upload';

const ReplyModel = BackendBaseModel.extend({
  commentId: z.string().uuid(),
  content: z.string(),
  userId: z.string().uuid(),
  attachments: AttachmentsModel,
});

export const RepliesModel = ReplyModel.array();

export const ReplyFormSchema = z.object({
  content: z.string().min(1),
  fileEntries: FileEntryModel.array().optional(),
});

export const CreateReplyParamsSchema = ReplyFormSchema.pick({
  content: true,
}).extend({
  commentId: z.string().uuid(),
  attachmentIds: z.string().array().optional(),
});

export const UpdateReplyParamsSchema = CreateReplyParamsSchema.extend({
  id: z.string().uuid(),
});

export const DeleteReplyParamsSchema = z.object({
  id: z.string().uuid(),
  commentId: z.string().uuid(),
});
